import {
  Chip, createStyles, makeStyles, Theme
} from '@material-ui/core';
import { InsuranceAutomationStatus } from '@roc/feature-insurance-review';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chipManual: {
      backgroundColor: theme.palette.success.main,
      color: 'white',
      marginLeft: theme.spacing(2),
    },
    chipAutomated: {
      backgroundColor: theme.palette.warning.main,
      color: 'white',
      marginLeft: theme.spacing(2),
    },
    chipInProgress: {
      backgroundColor: theme.palette.warning.main,
      color: 'white',
      marginLeft: theme.spacing(2),
    },
  })
);

export const InsuranceQuoteStatusChip = ({ properties }) => {
  const classes = useStyles();
  return (
    <Chip
      size="small"
      className={properties.status === InsuranceAutomationStatus.SUCCESS ? classes.chipAutomated :
        properties.status === InsuranceAutomationStatus.IN_PROGRESS ? classes.chipInProgress : classes.chipManual}
      label={properties.label}
    />
  );
};
